// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <div>
    <v-card class="ma-2">
      <v-card-title class="headline">
        Billing Information
      </v-card-title>
      <v-card-text v-if="filteredItems" class="noprint">
        Total Orgs: {{filteredItems.length}}
      </v-card-text>
      <v-divider></v-divider>
      <v-row class="mx-3 noprint" label="filters">
        <span class="ml-1 mr-3 my-8">Filters:</span>
        <v-col
        class="mx-2"
        cols="1"
        v-for="(filter, i) in filters"
        :key="i">
          <v-checkbox
          :label="filter.text"
          v-model="filter.value"
          @click="filterItems"
          >
          </v-checkbox>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-dataTable
        :headers="headers"
        :items="filteredItems"
        class="elevation-1"
        :items-per-page="25"
        :footer-props="{
          'items-per-page-options': [10, 25, 100, -1]
        }"
        >
      </v-dataTable>
    </v-card>
  </div>
</template>
<script>
import ItemList from 'vue-common/components/ItemList.vue'
import ApiRequests from '@/api/ApiRequests'

import { ENDPOINT } from '@/shared/constants'

export default {
  components: {
    ItemList
  },

  props: {
    searchBarText: String
  },

  data () {
    return {
      filters: [
        {
          text: 'Active',
          value: true
        },
        {
          text: 'Demo',
          value: true
        },
        {
          text: 'Internal',
          value: true
        },
        {
          text: 'Inactive',
          value: true
        }
      ],
      endpoint: ENDPOINT,
      items: [],
      filteredItems: [],
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Subdomain',
          value: 'subdomain'
        },
        {
          text: 'Users',
          value: 'users.length'
        },
        {
          text: 'API Keys',
          value: 'apikeys.length'
        },
        {
          text: 'Storage Usage',
          value: 'storage'
        },
        {
          text: 'Status',
          value: 'status'
        }
      ]
    }
  },

  methods: {
    getBillingInfo: function () {
      Promise.all([
        fetch(`${this.endpoint}organizations`).then(res => res.ok && res.json())
      ]).then(data => {
        // this.items = data[0] // included for dev
        // comment out for loop when testing to reduce API usage
        for (const i of data[0]) {
          Promise.all([
            fetch(`${this.endpoint}admin/storageusage?organization=${i.id}`).then(res => res.ok && res.json())
          ]).then(data => {
            var byte = `${this.bytesToGB(data[0].sum)}GB`
            i.storage = byte
            this.items.push(i)
          })
        }
        this.filteredItems = this.items
      })
    },

    filterItems: function () {
      this.filteredItems = this.items
      for (const x of this.filters) {
        if (x.value === false) {
          for (const y of this.filteredItems) {
            if (y.status === x.text.toLowerCase()) {
              this.filteredItems = this.filteredItems.filter(i => i !== y)
            }
          }
        }
      }
    },

    bytesToGB: function (v) {
      if (typeof v === 'number') {
        return (v / 1000000000).toFixed(3)
      }
      return (0).toFixed(3)
    }
  },

  created () {
    this.getBillingInfo()
    ApiRequests.getImages({limit: 1}).then(response => {
      this.images = parseInt(response.headers['x-total-count'])
    })
  }
}
</script>



// WEBPACK FOOTER //
// Billing.vue?af699324